import { CompleteToolCallNodeDataSchema } from '@cotera/api';
import { Ty } from '@cotera/era';
import type { WorkflowNodeData } from '../types';
import type { WorkflowNodeHydration } from '../workflow-node-base';
import type { WorkflowNodeOutputShapeContext } from '../workflow-node-output-shape';
import { TypedWorkflowNode } from './typed-workflow-node';

export class CompleteToolCallWorkflowNode extends TypedWorkflowNode<
  typeof CompleteToolCallNodeDataSchema
> {
  protected readonly schema = CompleteToolCallNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): CompleteToolCallWorkflowNode {
    return new CompleteToolCallWorkflowNode(data, hydration);
  }
  override deriveTypedOutputShape(
    _context: WorkflowNodeOutputShapeContext
  ): string | null {
    return Ty.displayTy(Ty.ty('string'));
  }

  protected override defaultDisplayName(): string {
    return 'Complete tool call';
  }
}
